<app-app-layout>
  <div class="sms-container">
    <div class="row">
      <div class="col-12">
        <app-user-info-card
          [email]="subscriberDetail.email"
          [name]="subscriberDetail.name"
        >
        </app-user-info-card>
      </div>
    </div>

    <app-gym-branch-selection-card
      [selectedBranchId]="selectedBranchId"
      (branchSelected)="onBranchSelected($event)"
    ></app-gym-branch-selection-card>

    <div class="sms-card">
      <mat-card>
        <div style="margin: 16px 0; text-align: center">
          <h5 style="margin: 0; font-weight: 600">Purchase Message Credit</h5>
        </div>

        <mat-card-content>
          <mat-form-field
            appearance="outline"
            style="width: 100%; margin-bottom: 10px"
          >
            <mat-label>Select Message Credit</mat-label>
            <mat-select [(ngModel)]="selectedCreditAmount">
              <mat-option *ngFor="let qty of smsOptions" [value]="qty">
                {{ qty }} Message credit
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Message Calculation Display -->
          <div *ngIf="selectedCreditAmount" class="message-calculation-card">
            <div class="calculation-header">
              <h6 class="calculation-title">
                With ₹{{ selectedCreditAmount }} credit, you can send:
              </h6>
            </div>
            <div class="message-counts">
              <div class="message-item">
                <div class="message-label">
                  <span>SMS Messages</span>
                </div>
                <div class="message-value">
                  <strong>{{ getSmsMessageCount() | number }}</strong>
                  <span class="message-unit">messages</span>
                </div>
              </div>
              <div class="message-item" *ngIf="isWhatsAppFeatureEnabled">
                <div class="message-label">
                  <span>WhatsApp Messages</span>
                </div>
                <div class="message-value">
                  <strong>{{ getWhatsAppMessageCount() | number }}</strong>
                  <span class="message-unit">messages</span>
                </div>
              </div>
            </div>
            <div class="calculation-details">
              <div class="calculation-item">
                <span class="calc-label">SMS:</span>
                <span class="calc-formula">
                  ₹{{ selectedCreditAmount }} ÷ ₹{{ COST_PER_SMS }} =
                  <strong>{{ getSmsMessageCount() | number }} messages</strong>
                </span>
              </div>
              <div class="calculation-item" *ngIf="isWhatsAppFeatureEnabled">
                <span class="calc-label">WhatsApp:</span>
                <span class="calc-formula">
                  ₹{{ selectedCreditAmount }} ÷ ₹{{ COST_PER_WHATSAPP }} =
                  <strong
                    >{{ getWhatsAppMessageCount() | number }} messages</strong
                  >
                </span>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Billing Information Card -->
    <div class="billing-card">
      <mat-card>
        <mat-card-header>
          <mat-card-title>Billing Information</mat-card-title>
          <mat-card-subtitle
            >Please provide your billing details for invoice
            generation</mat-card-subtitle
          >
        </mat-card-header>

        <mat-card-content>
          <div class="form-row">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Country</mat-label>
              <input
                type="text"
                matInput
                [matAutocomplete]="autoCountry"
                [formControl]="billingForm.get('country')"
                (input)="onCountryInput($event)"
                placeholder="Search country..."
              />
              <mat-autocomplete
                #autoCountry="matAutocomplete"
                [displayWith]="getCountryDisplayValue"
                (optionSelected)="onCountrySelected($event.option.value)"
              >
                <mat-option *ngFor="let c of filteredCountries" [value]="c">{{
                  c.label
                }}</mat-option>
              </mat-autocomplete>
              <mat-error>Country is required</mat-error>
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field appearance="outline" class="half-width">
              <mat-label>State</mat-label>
              <input
                type="text"
                matInput
                [matAutocomplete]="autoState"
                [formControl]="billingForm.get('state')"
                (input)="onStateInput($event)"
                placeholder="Search state..."
              />
              <mat-autocomplete
                #autoState="matAutocomplete"
                [displayWith]="getStateDisplayValue"
                (optionSelected)="onStateSelected($event.option.value)"
              >
                <mat-option *ngFor="let s of filteredStates" [value]="s">{{
                  s.state
                }}</mat-option>
              </mat-autocomplete>
              <mat-error>State is required</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="half-width">
              <mat-label>District</mat-label>
              <input
                type="text"
                matInput
                [matAutocomplete]="autoDistrict"
                [formControl]="billingForm.get('district')"
                (input)="onDistrictInput($event)"
                placeholder="Search district..."
              />
              <mat-autocomplete
                #autoDistrict="matAutocomplete"
                (optionSelected)="onDistrictSelected($event.option.value)"
              >
                <mat-option
                  *ngFor="let d of filteredDistricts; trackBy: trackByDistrict"
                  [value]="d"
                  >{{ d }}</mat-option
                >
              </mat-autocomplete>
              <mat-error>District is required</mat-error>
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field appearance="outline" class="half-width">
              <mat-label>Pincode</mat-label>
              <input
                matInput
                type="text"
                maxlength="6"
                [formControl]="billingForm.get('pinCode')"
              />
              <mat-error>Valid 6-digit pincode required</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="half-width">
              <mat-label>Gym Name (optional)</mat-label>
              <input
                matInput
                type="text"
                [formControl]="billingForm.get('gymName')"
              />
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Address</mat-label>
              <textarea
                matInput
                rows="2"
                [formControl]="billingForm.get('addressLine')"
                required
              ></textarea>
              <mat-error>Address is required</mat-error>
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-label>Are you registered for GST?</mat-label>
            <mat-radio-group
              [formControl]="billingForm.get('hasGST')"
              class="inline-radios"
            >
              <mat-radio-button [value]="true">Yes</mat-radio-button>
              <mat-radio-button [value]="false">No</mat-radio-button>
            </mat-radio-group>
          </div>

          <div class="form-row" *ngIf="billingForm.get('hasGST')?.value">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>GST Number</mat-label>
              <input
                matInput
                type="text"
                [formControl]="billingForm.get('gstNumber')"
              />
              <mat-hint>Format: 22AAAAA0000A1Z5</mat-hint>
              <mat-error
                *ngIf="billingForm.get('gstNumber')?.hasError('required')"
                >GST Number is required</mat-error
              >
              <mat-error
                *ngIf="billingForm.get('gstNumber')?.hasError('pattern')"
                >Invalid GST format</mat-error
              >
            </mat-form-field>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Review & Pay Card -->
    <div class="review-card" *ngIf="isGstFeatureEnabled">
      <mat-card>
        <mat-card-header>
          <mat-card-title>Review & Pay</mat-card-title>
          <mat-card-subtitle
            >Review your order and complete payment</mat-card-subtitle
          >
        </mat-card-header>

        <mat-card-content>
          <div class="amount-row">
            Subtotal: ₹{{ getBaseAmount() | number : "1.2-2" }}
          </div>
          <div class="amount-row">
            GST (18%): ₹{{ getGstAmount() | number : "1.2-2" }}
          </div>
          <div class="amount-total">
            Total Payable: ₹{{ getTotalAmountWithGst() }}
          </div>
        </mat-card-content>

        <mat-card-actions>
          <button
            mat-raised-button
            color="primary"
            class="pay-now-button"
            (click)="payNow()"
          >
            Pay ₹{{ getTotalAmountWithGst() }} Now
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
  </div>
</app-app-layout>
